import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import React from 'react';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';
import TalentMeshButterfly from './tmbutterfly.svg';
import { Button } from '@/Components/shadcn/button';

export interface Pagination {
    index: number;
    total: number;
}

export interface DialogHeaderProps {
    testType: TestTypes;
    pagination: Pagination;
    onClickClose: () => void;
    onNext: () => void;
    onPrevious: () => void;
}

const DialogHeader = ({
    testType,
    pagination: { index, total },
    onClickClose,
    onNext,
    onPrevious,
}: DialogHeaderProps) => {
    const headerDescription = UIStrings.TalentMeshTestPreviewQuestions(testType);
    const isNavigable = !!total;

    return (
        <header className="border-border bg-card z-10 flex shrink-0 items-center gap-3 border-b px-4 py-3 shadow-sm">
            <div className="border-border flex aspect-square shrink-0 items-center justify-center rounded-full border p-2">
                <img src={TalentMeshButterfly} alt="" className="h-full w-full max-w-9 object-contain" />
            </div>
            <div className="min-w-0 flex-1">
                <p className="text-foreground text-sm font-bold">{UIStrings.PreviewQuestions}</p>
                <p className="text-muted-foreground text-sm">
                    {headerDescription} {isNavigable && `${index + 1}/${total}`}
                </p>
            </div>
            {isNavigable && (
                <div className="hidden shrink-0 flex-row gap-2 sm:flex">
                    <Button type="button" variant="outline" size="sm" onClick={() => onPrevious()} disabled={!index}>
                        <ChevronLeft className="mr-1 size-4" />
                        {UIStrings.Previous}
                    </Button>
                    <Button
                        type="button"
                        variant="default"
                        size="sm"
                        onClick={() => onNext()}
                        disabled={index + 1 === total}
                    >
                        {UIStrings.Next}
                        <ChevronRight className="ml-1 size-4" />
                    </Button>
                </div>
            )}
            <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                onClick={onClickClose}
                className="shrink-0"
                aria-label="Close"
                data-testid="CloseIcon"
            >
                <X className="size-4" />
            </Button>
        </header>
    );
};

export default DialogHeader;
